export function timeToMinutes(t: string) {
  const [h, m] = t.slice(0, 5).split(":").map(Number);
  return h * 60 + m;
}

export function minutesToTime(m: number) {
  const h = Math.floor(m / 60);
  const min = m % 60;
  return `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
}

export interface DragState {
  startDay: number;
  startSlot: number;
  endDay: number;
  endSlot: number;
}

export interface QuickForm {
  days: number[];
  startTime: string;
  endTime: string;
  price: number;
  isPeak: boolean;
  name: string;
}

export interface EditForm {
  ruleId: string;
  name: string;
  price: number;
  isPeak: boolean;
  startTime: string;
  endTime: string;
  days: number[];
}

export interface MoveDragState {
  ruleId: string;
  rule: any;
  originDay: number;
  originStartMin: number;
  originEndMin: number;
  durationMin: number;
  currentDay: number;
  currentStartMin: number;
}

export const dayNames = ["Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag", "Söndag"];
export const dayShort = ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"];

export function formatDayRange(days: number[]) {
  if (days.length === 1) return dayNames[days[0] - 1];
  return `${dayShort[days[0] - 1]}–${dayShort[days[days.length - 1] - 1]}`;
}
